// Imports MUI Components
import { Box, Typography, Button, Stack } from "@mui/material";
import React, { useEffect, useState } from "react";

// Import Assets
import caution from "../../../../assets/caution.png";
import verification from "../../../../assets/verification.png";
import success from "../../../../assets/approve.png";

// Import CSS
import "./styles.css";
import Text from "../../atoms/text/Text";
import Icon from "../../atoms/icon/Icon";

const AlertShortMessage = ({ 
  type,
  label,
  variant,
  src
}) => {
  const [visible, setVisible] = useState(true);

  // Auto-hide after 2 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
    }, 4000);
    return () => clearTimeout(timer);
  }, []);

  if (!visible) return null; // Don’t render after hiding

  return (
    <Box
      sx={{
        zIndex: 1000,
        position: "absolute",
        top: "50px",
        left: "50%",
        transform: "translateX(-50%)",
        backgroundColor: "transparent",
      }}
    >
      <Stack
        spacing={2}
        direction="row"
        sx={{
          zIndex: 9999,
          position: "relative",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          fontWeight: "bold",
          fontSize: "16px",
          padding: "10px 20px",
          backgroundColor: type === "success" ? "#7abb8eff" : "#9F4223",
          borderRadius: "10px",
          boxShadow: "0 1px 10px rgba(46, 45, 45, .6)",
          whiteSpace: "nowrap", // ✅ Ensures text stays on one line
        }}
      >
        <Box
          sx={{
            backgroundColor: "transparent",
            border: type === "success" ? "2px solid #558363" : "2px solid #9F4223",
            borderRadius: "50px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
            width: "40px",
            height: "40px",
            flexShrink: 0,
          }}
        >
          <Icon src={src} size="small" />
        </Box>

        <Text
          text={label}
          variant={variant}
          sx={{
            whiteSpace: "nowrap",  // ✅ Force text to stay on one line
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "250px", // Prevents overflow if text is too long
          }}
        />

        <Button
          disableRipple
          onClick={() => setVisible(false)} // ✅ Close manually
          sx={{
            background: "none",
            color: "#2C251E",
            padding: "7px",
            borderRadius: "50px",
            cursor: "pointer",
            minWidth: "40px",
            minHeight: "40px",
            ":hover": {
              background: "rgba(0, 0, 0, 0.1)",
            },
          }}
        >
          X
        </Button>
      </Stack>
    </Box>
  );
};

export default AlertShortMessage;
